var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-menu",
    {
      attrs: {
        "close-on-content-click": false,
        "close-on-click": false,
        "offset-y": "",
        right: "",
        top: "",
        "nudge-width": 500,
        "max-width": "500",
      },
      scopedSlots: _vm._u([
        {
          key: "activator",
          fn: function ({ on }) {
            return [
              _c(
                "v-btn",
                _vm._g(
                  {
                    staticClass: "checkBtn",
                    attrs: {
                      outline: "",
                      color: "info",
                      disabled: _vm.checkBtnDisabled,
                    },
                  },
                  on
                ),
                [
                  _c("v-icon", [_vm._v("build")]),
                  _vm._v(_vm._s(_vm.$t("Button.Check")) + "\n    "),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.testMenu,
        callback: function ($$v) {
          _vm.testMenu = $$v
        },
        expression: "testMenu",
      },
    },
    [
      _vm._v(" "),
      _c(
        "v-card",
        [
          _c(
            "v-card-text",
            [
              _c("div", [
                _vm._v("Input Formula : "),
                _c("span", { staticClass: "formula-text" }, [
                  _vm._v(_vm._s(_vm.Formula)),
                ]),
              ]),
              _vm._v(" "),
              _vm.variable && _vm.variable.length
                ? _c("div", [
                    _vm._v("Please enter variable test value and unit."),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.variable, function (item, index) {
                return _c(
                  "v-form",
                  { key: index },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "" } },
                      [
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pr-1": "" } },
                          [
                            _c("v-text-field", {
                              attrs: {
                                label: item.name + " value",
                                rules: [_vm.rules.required, _vm.rules.numeric],
                              },
                              model: {
                                value: item.value,
                                callback: function ($$v) {
                                  _vm.$set(item, "value", $$v)
                                },
                                expression: "item.value",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-flex",
                          { attrs: { xs6: "", "pl-1": "" } },
                          [
                            _c("v-autocomplete", {
                              attrs: {
                                label: item.name + " unit",
                                items: _vm.allUnits,
                                "item-text": "Name",
                              },
                              model: {
                                value: item.unit,
                                callback: function ($$v) {
                                  _vm.$set(item, "unit", $$v)
                                },
                                expression: "item.unit",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                )
              }),
              _vm._v(" "),
              _c(
                "v-alert",
                { attrs: { value: _vm.showAlert, type: "warning" } },
                [
                  _vm._v(
                    "Testing value and unit could be empty.Please input the value and unit."
                  ),
                ]
              ),
              _vm._v(" "),
              _vm.showResult
                ? _c(
                    "v-card",
                    {
                      class: _vm.valid ? "background-true" : "background-false",
                    },
                    [
                      _c("v-card-title", { attrs: { "primary-title": "" } }, [
                        _c("div", [
                          _c("h3", [_vm._v("Result: " + _vm._s(_vm.result))]),
                          _vm._v(" "),
                          _c("div", [_vm._v(_vm._s(_vm.message))]),
                        ]),
                      ]),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { small: "", dark: "", color: "add" },
                  on: {
                    click: function ($event) {
                      return _vm.checkFormula()
                    },
                  },
                },
                [
                  _c("v-icon", [_vm._v("build")]),
                  _vm._v(_vm._s(_vm.$t("Button.Check")) + "\n      "),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { small: "", outline: "", color: "secondary" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(_vm._s(_vm.$t("Button.Cancel")))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }